import { Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "./Header";
import Homepage from "./Homepage";
import Article from "./Article";
import Search from "./Search";
import SearchResults from "./SearchResults";
import Category from "./Category";
import SubCategory from "./SubCategory";
import Footer from "./Footer";
import Contact from "./Contact";
import "./scss/style.css";

function App() {
  const [data, setData] = useState([]);

  useEffect(() => {
    loadData();

    window.onscroll = function (e) {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      var header = document.querySelector(".header");

      scrollY < this.lastScroll ? header.classList.remove("hide") : header.classList.add("hide");
      this.lastScroll = scrollY;

      scrollY == 0 ? header.classList.add("top-of-page") : header.classList.remove("top-of-page");
    };
  }, []);

  const fetchURL = "https://static-files.bgwgroup.com.au/theme-cnw/help-centre/data-cnw.json";
  const dateURL = Date.now();

  const loadData = async () => {
    await fetch(fetchURL+"?date="+dateURL)
      .then((response) => response.json())
      .then((recievedData) => {
        console.log(recievedData);
        setData(recievedData);
      })
      .catch((error) => {
        console.log(error);
        document.querySelector("#app div").innerHTML = `An error has occured. Please contact&nbsp;<a href="mailto:online.support@bgwgroup.com.au">online.support@bgwgroup.com.au</a>&nbsp;or call&nbsp;<a href="tel:1300 131 282">1300 131 282</a>.`;
      });
  };

  return (
    <>
      {data.length < 1 ? (
        <div
          className="loadingMsg"
          style={{
            display: "flex",
            color: "#999",
            width: "100%",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Loading Help Centre
        </div>
      ) : (
        <>
          <div id="app-wrapper">
            <Header data={data} />
            <Search data={data} />
            <div className="app-content">
              <div className="app-content-inner">
                <Routes>
                  <Route path="/article/:question/:id" element={<Article data={data} />} />
                  <Route path="/article/:question/:id" element={<Article data={data} />} />
                  <Route path="/category:id/:category:id" element={<Article data={data} />} />
                  <Route path="/category/:category/:category" element={<SubCategory data={data} />} />
                  <Route path="/category/:category" element={<Category data={data} />} />

                  <Route path="/category/contact" element={<Contact />} />

                  <Route exact path="/" element={<Homepage data={data} />} />

                  <Route path="/search/:query" element={<SearchResults data={data} />} />

                  <Route path="/search" element={<SearchResults data={data} />} />
                </Routes>
              </div>
            </div>
          </div>
          <Footer data={data} />
        </>
      )}
    </>
  );
}

export default App;
